// Sovelluksen versiohistoria. Uusin ensin.
// APP_VERSION = ylin versio; kun se muuttuu, käyttäjälle näytetään "mitä uutta" -kooste.

export const CHANGELOG = [
    {
        version: '1.7.2',
        date: '2026-08-10',
        title: 'Nopeampi uudelleenreititys',
        changes: [
            'Jos ajat risteyksestä ohi tai poikkeat reitiltä, sovellus huomaa sen nyt nopeammin ja laskee uuden reitin nykyisestä sijainnista.',
            'Selvä poikkeama (selkeästi väärä suunta) reitittää uudelleen jo muutamassa sekunnissa; pieni heilahdus reitin lähellä ei enää turhaan laukaise uudelleenlaskentaa.',
        ],
    },
    {
        version: '1.7.1',
        date: '2026-08-05',
        title: 'Selkeämmät kääntymisohjeet',
        changes: [
            'Kääntymiskortti näyttää nyt TULEVAN käännöksen (esim. "Nils Grabbes gata") eikä nykyistä ajettavaa tietä.',
            'Kääntymisohje mahtuu mobiilissa kokonaan näkyviin ilman vetämistä.',
            'GPS-katkos ei enää keskeytä navigointia nopeasti: matkaa jatketaan reittiä pitkin jopa 5 min ilman signaalia, jos ajetaan eikä olla vielä perillä.',
        ],
    },
    {
        version: '1.7.0',
        date: '2026-08-04',
        title: 'Norja mukaan ja saapumisennuste',
        changes: [
            'Reititys laajeni Norjaan: nyt Suomi, Ruotsi, Tanska ja Norja ovat samassa graafissa (esim. Oslo, Bergen, Tromsø).',
            'Navigointiin lisättiin saapumisennuste: arvioitu kellonaika perillä, jäljellä olevat kilometrit ja jäljellä oleva aika.',
            'Saapumisaika reagoi todelliseen ajovauhtiin, ei pelkkään reitin oletukseen.',
        ],
    },
    {
        version: '1.6.0',
        date: '2026-08-04',
        title: 'Kirjautuminen käyttöön ja vakaampi navigointi',
        changes: [
            'Sovellus vaatii nyt kirjautumisen – anonyymi käyttö poistui. Ensikäynnillä kysytään oletusliikkumistapa ja kotiosoite.',
            'GPS-katkoksessa (tunneli, katve) navigointi jatkaa matkaa reittiä pitkin viimeksi mitatulla vauhdilla – kartta ei enää pysähdy "seinään" eikä hyppi.',
            'Jos GPS näyttää sinun olevan paikallasi, navigointi pysyy paikallaan eikä etene itsestään.',
            'Sama tie ei enää kuulu uudelleen ("jatka tietä 101"), vaikka GPS heilahtaisi hetkeksi.',
            'Paikannuksen virheilmoitus näytetään suomeksi (esim. sijainnin jaon salliminen).',
        ],
    },
    {
        version: '1.5.4',
        date: '2026-07-27',
        title: 'Mobiilin manööverinuolet',
        changes: [
            'Navigointilaatikko käyttää nyt isoa Waze-tyylistä SVG-nuolta tekstinuolen sijaan.',
            'Mobiilissa manööverilaatikko pakotetaan selkeään pystyasetteluun.',
            'Käsin zoomauksen jälkeen lähinäkymän palautus toimii varmemmin noin 3 sekunnin viiveellä.',
        ],
    },
    {
        version: '1.5.3',
        date: '2026-07-27',
        title: 'Selkeämpi navigointinäkymä',
        changes: [
            'Navigoinnin aikana näytetään isompi käännöslaatikko: etäisyys, suunta ja ryhmittymisvihje.',
            'Kartta seuraa lähialuetta automaattisesti Google/TomTom-tyylisesti.',
            'Jos käyttäjä zoomaa tai siirtää karttaa itse, automaattinen lähinäkymä palautuu noin 3 sekunnin jälkeen.',
        ],
    },
    {
        version: '1.5.2',
        date: '2026-07-27',
        title: 'Sään muutosten varoitukset',
        changes: [
            'Kirjautuneen käyttäjän reittisää tarkistetaan taustalla noin 5 minuutin välein.',
            'Sovellus varoittaa, jos reitin sää muuttuu poutaisesta sateiseksi tai sade/lumisade voimistuu.',
            'Säävaroitus näkyy reittikoosteessa ja navigoinnin aikana kartan päällä.',
        ],
    },
    {
        version: '1.5.1',
        date: '2026-07-27',
        title: 'Kevyempi reittihaku ja sijainnin seuranta',
        changes: [
            'Reitin lasku ehdottaa kirjautumista, mutta antaa jatkaa myös anonyymisti ilman sää- ja premium-ominaisuuksia.',
            'Kulkutapa, reittivalinta ja lähtöaika siirrettiin reittiasetusten rattaan taakse.',
            'Kartalla voi seurata omaa sijaintia ilman reittisuunnitelmaa.',
        ],
    },
    {
        version: '1.5.0',
        date: '2026-07-27',
        title: 'Pohjoismaiden reitit ja lautat',
        changes: [
            'Reititys laajeni Pohjois-Euroopan kartta-aineistoon: Suomi, Ruotsi, Tanska ja Norja.',
            'Suomi-Ruotsi-lautat voidaan lisätä reittiin, jotta esimerkiksi København-reitit eivät jää Suomen puolelle.',
            'Pitkille reiteille lisättiin suojarajat, timeoutit ja kevyempi sääpisteytys, jotta palvelu ei kuormitu liikaa.',
        ],
    },
    {
        version: '1.4.0',
        date: '2026-07-01',
        title: 'Vakaampi kartta ja versiohistoria',
        changes: [
            'Kartta pysyy pohjoisessa – sormizoomaus ei enää pyöritä karttaa hyppysissä.',
            'Uusi versiohistoria: näet asetuksista mitä sovelluksessa on muuttunut.',
            'Kirjautuessa näytetään lyhyt kooste uusimmista muutoksista.',
        ],
    },
    {
        version: '1.3.0',
        date: '2026-06-30',
        title: 'Reitin muokkaus ja kiertoreitit',
        changes: [
            'Lähtö- ja kohdeosoitetta voi muokata suoraan reittikoosteesta klikkaamalla.',
            '"Muuta"-nappi avaa haun uudelleen reittikoosteesta.',
            'Reitti ohjautuu vaihtoehtoiselle tielle, jos matkalla on este (kolari tai sulku).',
        ],
    },
    {
        version: '1.2.0',
        date: '2026-06-29',
        title: 'Ajoneuvoprofiili ja lataus',
        changes: [
            'Ajoneuvoprofiili: käyttövoima (sähkö/bensa/kaasu) ja kulutus.',
            'Kulutusarvio matkalle ja järkevät latausehdotukset sähköautolle.',
            'Latauspisteet kartalla (Digitraffic AFIR + Open Charge Map).',
        ],
    },
    {
        version: '1.1.0',
        date: '2026-06-28',
        title: 'Liikenne ja ruuhkat',
        changes: [
            'Reittiviiva värjätään ruuhkan mukaan (punainen = tukkoista, oranssi = hidasta).',
            'Liikenteen häiriöt ja tietyöt näkyvät kartalla (Digitraffic).',
            'Ruuhka-arvio ja reittisuositus viiveen mukaan.',
        ],
    },
    {
        version: '1.0.0',
        date: '2026-06-27',
        title: 'Ensimmäinen versio',
        changes: [
            'Reittihaku sekä sää ja tuulet reitin varrella.',
            'Mobiiliystävällinen navigointinäkymä.',
            'Kirjautuminen ja anonyymi käyttö.',
        ],
    },
];

export const APP_VERSION = CHANGELOG[0].version;
